import { AppConnectionStatuses } from '../../../../constants/appConnectionStatuses';
import { DashworksServiceComponent } from './DashworksServiceComponent';
export const DashworksReconnectionConfig = {
  reconnectButton: null,
  statusesForDisplaying: [AppConnectionStatuses.UPDATE_AVAILABLE, AppConnectionStatuses.DISCONNECTED],
  serviceComponent: DashworksServiceComponent
};